module.exports = __webpack_public_path__ + "static/img/1039_small.928a46d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1039_small.png
// module id = bPvI
// module chunks = 1